import { GalleryList } from './gallery'

class OverviewSalesList extends GalleryList {

    getEntityKey() {
        return 'photographer/overview_sales/totals'
    }
}

export const overviewSalesList = new OverviewSalesList('overview_sales_default')

class OverviewSalesPhotosSoldList extends GalleryList {

  getEntityKey() {
    return 'photographer/overview_sales/photos_sold'
  }

  getData({ created_at_date_from, created_at_date_to }) {
    return this.saveNewObject({
      created_at_date_from: created_at_date_from,
      created_at_date_to: created_at_date_to,
    })
  }
}

export const overviewSalesPhotosSoldList = new OverviewSalesPhotosSoldList('overview_sales_photos_sold_default')
